<template>
  <v-col cols="5">
    <v-card class="align-start metrics-card-top">
      <v-card-title class="d-flex justify-space-between">
        <div class="hidden-element">Hidden</div>
        <!--Hidden element to allow center and right align of label and icon-->
        <div>
          <label class="font-weight-bold text-decoration-underline">Customer Overview</label>
          <v-btn icon @click="updateHealthScore">
            <v-icon medium>
              mdi-pencil
            </v-icon>
          </v-btn>
        </div>
        <tooltip>
          <p>
            <label class="mdi mdi-emoticon-happy-outline mdi-24px green--text"></label> Doing well -
            The customer is doing well!</p>
          <p>
            <label class="mdi mdi-emoticon-neutral-outline mdi-24px yellow--text"></label> Take Notice - The
            customer is somewhere in between. Left unchecked
            they may deteriorate to poor health.</p>
          <p>
            <label class="mdi mdi-emoticon-sad-outline mdi-24px red--text"></label> Requires Attention! - The
            customer is not doing well. Left unchecked they will likely
            cancel at next renewal date.</p>
        </tooltip>
      </v-card-title>
      <div class="d-flex flex-row mb-6 bg-surface-variant">
        <whizeo-health-score />
        <chat-system-score v-if="chatScoreNotFailed" />
        <v-card-text class="d-flex flex-column justify-space-around align-center metrics-card-text">
          <div class="d-flex flex-column align-center">
            <p class="text--primary">CSM Sentiment</p>
            <p>(Last updated: {{ satisfactionLevelLastUpdated }})</p>
          </div>
          <health-score-icon :satisfaction-level="satisfactionLevel" />
          <label class="text--primary">{{ customerSentiment }}</label>
        </v-card-text>
      </div>
      <update-health-score-dialog :is-open="isUpdateHealthScoreDialogOpen" :client-id="clientId"
                                  :current-satisfaction-level="satisfactionLevel"
                                  @close="closeUpdateDialog"/>
    </v-card>
  </v-col>
</template>

<script>
import UpdateHealthScoreDialog from "../../components/HealthScore/UpdateHealthScoreDialog.vue";
import i18n from '../../setup/locale/en';
import Tooltip from "@/components/HealthScore/Tooltip.vue";
import {mapState} from "vuex";
import {dateToLocaleTimeDateString} from "@/helpers/dateHelper";
import HealthScoreIcon from "@/components/HealthScore/CustomerOverview/HealthScoreIcon.vue";
import ChatSystemScore from "@/components/HealthScore/CustomerOverview/ChatSystemScore.vue";
import WhizeoHealthScore from "@/components/HealthScore/CustomerOverview/WhizeoHealthScore.vue";
import {LoadingState} from "@/store/constants";

export default {
  name: 'CustomerOverview',
  components: {
    WhizeoHealthScore,
    ChatSystemScore,
    HealthScoreIcon,
    Tooltip,
    UpdateHealthScoreDialog,
  },
  props: {
    satisfactionLevel: Number,
    clientId: Number
  },
  data: () => ({
    isUpdateHealthScoreDialogOpen: false,
  }),
  computed: {
    ...mapState('clientStore', ['clients']),
    ...mapState('healthScoreStore', ['chatSystemScore']),
    chatScoreNotFailed() {
      return this.chatSystemScore.state !== LoadingState.FAILED;
    },
    satisfactionLevelLastUpdated() {
      const client = this.clients.find((client) => client.clientId === this.clientId);
      return client ? dateToLocaleTimeDateString(client.satisfactionLevelLastUpdated) : '';
    },
    customerSentiment() {
      switch (this.satisfactionLevel) {
        case 0:
          return i18n.clients.healthScore.labels.sadHealthScore;
        case 5:
          return i18n.clients.healthScore.labels.neutralHealthScore;
        case 10:
          return i18n.clients.healthScore.labels.happyHealthScore;
        default:
          return '-';
      }
    }
  },
  methods: {
    closeUpdateDialog() {
      this.isUpdateHealthScoreDialogOpen = false;
    },
    updateHealthScore() {
      this.isUpdateHealthScoreDialogOpen = true;
    },
  }
}
</script>
